<template>
  <div class="robot-wrapper">
    <section id="robot">
      <div class="robot-header">
        <h2 id="our-robot"><a href="#our-robot" class="header-link">Our Robot</a></h2>
      </div>
      <!-- <div class="robot-image">
        <img src="@/assets/Integrity_2024-12.png" alt="Integrity 2024 Robot Model" class="image">
      </div> -->
      <div class="info-row">
        <div class="message-wrapper">
          <h3 id="manny"><a href="#manny" class="header-link">Manny the Manatee</a></h3>
          <MarkdownRenderer :content="$store.state.content.robot" />
        </div>
        <div class="pdf-wrapper">
          <PdfViewer :pdfUrl="$store.state.general.robotPosterURL || '/2026 Robot Design Showcase Poster.pdf'" />
        </div>
      </div>
      <div class="carousel-wrapper">
        <InfiniteCarousel name="Robot" :images="robotImages" :speed="-0.3"/>
      </div>
    </section>
    <MovingDivider :bottom="true" :index="2" />
  </div>
</template>

<script>
import MovingDivider from '@/components/MovingDivider.vue'
import InfiniteCarousel from '@/components/InfiniteCarousel.vue'
import PdfViewer from '@/components/PdfViewer.vue'
import MarkdownRenderer from '@/components/MarkdownRenderer.vue'

export default {
    name: "RobotsView",
    components: {
        MovingDivider,
        InfiniteCarousel,
        PdfViewer,
        MarkdownRenderer
    },
    computed: {
      robotImages() {
        return this.$store.state.galleries?.robot || [];
      }
    }
}
</script>

<style lang="scss">
.robot-wrapper{
    position: relative;
    background-color: var(--regular);
    color: var(--white);
    
    .header-link:focus {
        outline-color: var(--white);
    }
    // height: 120vh;

  p {
    a {
        // color: var(--medium);
      text-decoration: underline;
      font-weight: bold;
    }
  }

    #robot{
        margin: auto;
        padding: var(--section-padding);
        padding-top: 10em;
        padding-bottom: 2rem;
        font-size: 1rem;
        line-height: 1.35;
        max-width: var(--max-width);
        
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .robot-image {
          display: flex;
          justify-content: center;
          margin-bottom: 2em;
          .image {
            width: 100%;
            max-width: 800px;
            height: auto;
          }
        }

        .info-row {
          display: flex;
          flex-direction: column;
          width: 100%;
          justify-content: center;
          align-items: center;

          h3 {
            text-align: center;
            font-size: 1.25rem;
            margin-bottom: 0.5em;
          }

          .message-wrapper {
            width: 100%;
            max-width: 100%;
            text-align: justify;
            line-height: 1.35;
          }
          .pdf-wrapper {
            width: 100%;
            max-width: 100%;
            margin-top: 1em;
            aspect-ratio: 4 / 3;
          }
        }

        .carousel-wrapper {
          margin-top: 1em;
        }
    }
}

@media screen and (max-width: 768px) {
  .robot-wrapper {
    #robot {
      padding: 5.5rem var(--section-padding-mobile, 6%) 1.5rem;
      font-size: 0.95rem;

      .info-row {
        h3 {
          font-size: 1.15rem;
        }

        .message-wrapper {
          text-align: left;
          line-height: 1.35;
        }

        .pdf-wrapper {
          margin-top: 0.75rem;
        }
      }
    }
  }
}
</style>